import React from "react";
import { Row, Col } from "react-bootstrap";

import AgreementCheckbox from "../../../controls/AgreementCheckbox";

function PaymentAgreementBlock() {
  return (
    <Row>
      <Col xs={12}>
        <div className="input-label">
          <span>Agreement<span>*</span></span>
        </div>
      </Col>
      <Col xs={12}>
        <AgreementCheckbox
          id="formAgreement"
          label={(
            <span>
              I accept the Terms and Conditions
            </span>
          )}
        />
      </Col>
    </Row>
  );
}

export default PaymentAgreementBlock;
